export const DESIGN_APPROVAL_ACTIONS_REQUEST =
  "API/ENTITIES/DESIGN_APPROVAL_ACTIONS_REQUEST";
export const DESIGN_APPROVAL_ACTIONS_REQUEST_FAILURE =
  "API/ENTITIES/DESIGN_APPROVAL_ACTIONS_REQUEST_FAILURE";
export const DESIGN_APPROVAL_ACTIONS_REQUEST_SUCCESS =
  "API/ENTITIES/DESIGN_APPROVAL_ACTIONS_REQUEST_SUCCESS";
